import { Controller } from "@hotwired/stimulus"

let FancyboxLib = null

async function loadFancybox() {
  if (FancyboxLib) return FancyboxLib

  const module = await import("@fancyapps/ui")
  FancyboxLib = module.Fancybox || module.default?.Fancybox || module.default

  return FancyboxLib
}

export default class FancyboxController extends Controller {
  async connect() {
    this.Fancybox = await loadFancybox()

    this.Fancybox.bind(this.element, "[data-fancybox]", {
      Hash: false,
      Carousel: {
        Video: {
          autoplay: false
        },
        Toolbar: {
          display: {
            left: [],
            middle: [],
            right: ["close"]
          }
        }
      }
    })
  }

  disconnect() {
    this.Fancybox?.unbind?.(this.element, "[data-fancybox]")
    this.Fancybox?.destroy?.()
  }
}